import { api } from "./api"
import type { JsonBody, JsonResponse, paths } from "./generated"

type AnalyticsMetric = JsonResponse<paths["/api/analytics/metrics/{metric}"]["get"]>[number]
type AnalyticsMetricsCsv = JsonResponse<paths["/api/analytics/csv"]["get"]>

const analyticsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		sendAnalyticsEvent: builder.mutation<void, JsonBody<paths["/api/analytics"]["post"]>>({
			query: (body) => ({
				url: "/analytics",
				method: "POST",
				body,
			}),
		}),
		getAnalyticsMetric: builder.query<AnalyticsMetric[], { metric: string; locale?: unknown }>({
			query: ({ metric }) => ({
				url: `/analytics/metrics/${metric}`,
				method: "GET",
			}),
		}),
		getAnalyticsMetricsCsv: builder.query<AnalyticsMetricsCsv, void>({
			query: () => ({
				url: "/analytics/csv",
				method: "GET",
			}),
		}),
	}),
})

export const { useSendAnalyticsEventMutation, useGetAnalyticsMetricQuery, useGetAnalyticsMetricsCsvQuery } = analyticsApi
